import type { IXY } from './distanceUtil'

export function length2(x: number, y: number) {
  return Math.sqrt(x * x + y * y)
}
export function length(v: IXY) {
  return Math.sqrt(v.x * v.x + v.y * v.y)
}
export function normalizeSafe2(x: number, y: number) {
  let l = length2(x, y)
  if (l <= 0.001) {
    return { x: 1, y: 0 }
  }
  return { x: x / l, y: y / l }
}
export function normalizeSafe(v: IXY) {
  let l = length(v)
  if (l <= 0.001) {
    return { x: 1, y: 0 }
  }
  return { x: v.x / l, y: v.y / l }
}

export function create(x: number, y: number) {
  return { x, y }
}

export function scale(v: IXY, s: number) {
  return { x: v.x * s, y: v.y * s }
}

// export function moveTowardsXY(obj: IXY, target: IXY, max: number) {
//   let dx = target.x - obj.x
//   let dy = target.y - obj.y

//   let v = create(dx, dy)
//   let len = length(v)

//   if (len < max) {
//     return create(target.x, target.y)
//   }

//   v = normalizeSafe(v)
//   v = scale(v, max)
//   return v
// }

export function deltaTowardsXY(obj: IXY, target: IXY, max: number) {
  let dx = target.x - obj.x
  let dy = target.y - obj.y

  let v = create(dx, dy)
  let len = length(v)

  if (len < max) {
    return create(dx, dy)
  }

  v = normalizeSafe(v)
  v = scale(v, max)
  return v
}
